import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, computed } from 'vue'
import { useActivityStore } from '@/stores/activity';
import PromotionPopup from '@/themes/themeOne/promotion/promotionPopup.vue';
import PromotionPopupTwo from '@/themes/themeTwo/promotion/promotionPopup.vue';
import PromotionPopupThree from '@/themes/themeThree/promotion/promotionPage.vue';
import { PromotionData } from './supporrtScript';
import { useThemeStore } from '@/stores/theme';
import { useUserStore } from '@/stores/user';
import { useI18n } from 'vue-i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'promotionPopup',
  emits: ['handleClose', "openAgent", "openPWA"],
  setup(__props, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const themeStore = useThemeStore()
const activityStore = useActivityStore()
const promotionRef = ref()
const { t } = useI18n()
const show = ref(false)
const promotionList = computed<any>(() => activityStore.activityList)
    const canRecievedRewards = computed(() => userStore?.PWAConvertData?.canReceiveReward)
    const isPwaClaimed = computed(() => userStore?.PWAConvertData?.isPwaClaimed)
    const isOpen = computed(() => userStore?.PWAConvertData?.config?.isOpen)

const dataSet = computed<PromotionData>(() => ({
    show: show.value,
    promotionList: promotionList.value
}))

const emits = __emit
const open = () => {
    show.value = true
}
const close = () => {
    show.value = false
    emits('handleClose')
}
const openAgentPopup = () => {
    emits("openAgent")
}

const openPWAPopup = () => {
    if(themeStore.themeIndex === 3) {
        if (canRecievedRewards.value === 1) {
        if (isPwaClaimed.value === 1) {
            promotionRef.value.pwaStatusPoupOpen(t('activityStatus.completed'))
        } else {
            promotionRef.value.pwaStatusPoupOpen(t('rewards.notActivated'))
        }
    } else if (isOpen.value === 0) {
        promotionRef.value.pwaStatusPoupOpen(t('rewards.notActivated'))
    } else {
        promotionRef.value.pwaPoupOpen()
    }
    } else {
        emits("openPWA")
    }
    
}

__expose({
    open,
    close
})




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(themeStore).themeIndex === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(PromotionPopup, {
            "data-set": dataSet.value,
            onClose: close,
            onOpen: open,
            onOpenAgentPopup: openAgentPopup,
            onOpenPWAPopup: openPWAPopup
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(PromotionPopupTwo, {
            "data-set": dataSet.value,
            onClose: close,
            onOpen: open,
            onOpenAgentPopup: openAgentPopup,
            onOpenPWAPopup: openPWAPopup
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true),
    (_unref(themeStore).themeIndex === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(PromotionPopupThree, {
            "data-set": dataSet.value,
            ref_key: "promotionRef",
            ref: promotionRef,
            onOpenAgentPopup: openAgentPopup,
            onOpenPWAPopup: openPWAPopup
          }, null, 8, ["data-set"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})